module.exports = __webpack_public_path__ + "static/media/star-empty.31cf58b9.svg";